<template>
  <v-app>
    <v-dialog v-model="modalStatus" scrollable persistent>
      <v-card>
        <v-card-title>
          <span class="headline">Seguimiento del paciente</span>
        </v-card-title>
        <v-card-text>
          <div v-if="Object.keys(data).length">
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Fecha</th>
                    <th class="text-left">Presión arterial</th>
                    <th class="text-left">
                      Peso
                      <template
                        v-if="
                          undefined !== data.stats &&
                          0 !== Object.keys(data.stats).length
                        "
                      >
                        (
                        <v-icon>
                          mdi-{{ getIcon(patient.stats[0].weight) }}
                        </v-icon>
                        <span>
                          {{
                            patient.stats[0].weight +
                            " kg. (" +
                            patient.stats[0].weight_percentage +
                            " %)"
                          }}
                        </span>
                        )
                      </template>
                    </th>
                    <th class="text-left">
                      Grasa total
                      <template
                        v-if="
                          undefined !== data.stats &&
                          0 !== Object.keys(data.stats).length
                        "
                      >
                        (
                        <v-icon>
                          mdi-{{ getIcon(patient.stats[0].total_fat) }}
                        </v-icon>
                        <span>
                          {{ patient.stats[0].total_fat + " %" }}
                        </span>
                        )
                      </template>
                    </th>
                    <th class="text-left">
                      Músculo
                      <template
                        v-if="
                          undefined !== data.stats &&
                          0 !== Object.keys(data.stats).length
                        "
                      >
                        (
                        <v-icon>
                          mdi-{{ getIcon(patient.stats[0].muscle) }}
                        </v-icon>
                        <span>
                          {{ patient.stats[0].muscle + " %" }}
                        </span>
                        )
                      </template>
                    </th>
                    <th class="text-left">
                      Grasa visceral
                      <template
                        v-if="
                          undefined !== data.stats &&
                          0 !== Object.keys(data.stats).length
                        "
                      >
                        (
                        <v-icon>
                          mdi-{{ getIcon(patient.stats[0].visceral_fat) }}
                        </v-icon>
                        <span>
                          {{ patient.stats[0].visceral_fat }}
                        </span>
                        )
                      </template>
                    </th>
                    <th class="text-left">
                      Cintura 1
                      <template
                        v-if="
                          undefined !== data.stats &&
                          0 !== Object.keys(data.stats).length
                        "
                      >
                        (
                        <v-icon>
                          mdi-{{ getIcon(patient.stats[0].waist_1) }}
                        </v-icon>
                        <span>
                          {{
                            patient.stats[0].waist_1 +
                            " cm. (" +
                            patient.stats[0].waist_1_percentage +
                            " %)"
                          }}
                        </span>
                        )
                      </template>
                    </th>
                    <th class="text-left">
                      Cintura 2
                      <template
                        v-if="
                          undefined !== data.stats &&
                          0 !== Object.keys(data.stats).length
                        "
                      >
                        (
                        <v-icon>
                          mdi-{{ getIcon(patient.stats[0].waist_2) }}
                        </v-icon>
                        <span>
                          {{
                            patient.stats[0].waist_2 +
                            " cm. (" +
                            patient.stats[0].waist_2_percentage +
                            " %)"
                          }}
                        </span>
                        )
                      </template>
                    </th>
                    <th class="text-left">Kilocalorías</th>
                    <th class="text-left">Circunferencia brazo relajado</th>
                    <th class="text-left">Circunferencia brazo contraído</th>
                    <th class="text-left">Tórax</th>
                    <th class="text-left">Muslo</th>
                    <th class="text-left">Pantorrilla</th>
                    <th>Opciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="measure in data.measures" :key="measure.id">
                    <td>{{ formatDate(measure.date) }}</td>
                    <td>{{ measure.blood_pressure }}</td>
                    <td>{{ `${measure.weight} kg` }}</td>
                    <td>{{ `${measure.total_fat} %` }}</td>
                    <td>{{ `${measure.muscle} %` }}</td>
                    <td>{{ measure.visceral_fat }}</td>
                    <td>{{ `${measure.waist_1} cm` }}</td>
                    <td>{{ `${measure.waist_2} cm` }}</td>
                    <td>{{ `${measure.kilocalories} kcal` }}</td>
                    <td>{{ `${measure.relaxed_arm_circumference} cm` }}</td>
                    <td>{{ `${measure.contracted_arm_circumference} cm` }}</td>
                    <td>{{ `${measure.chest} cm` }}</td>
                    <td>{{ `${measure.thigh} cm` }}</td>
                    <td>{{ `${measure.calf} cm` }}</td>
                    <td>
                      <v-btn
                        @click="editMeasures(measure)"
                        class="mx-2"
                        color="yellow accent-4"
                        fab
                        x-small
                        dark
                      >
                        <v-icon dark>mdi-circle-edit-outline</v-icon>
                      </v-btn>
                      <v-btn
                        @click="showPDF(measure)"
                        class="mx-2"
                        color="red"
                        fab
                        x-small
                        dark
                      >
                        <v-icon dark>mdi-file-pdf-box</v-icon>
                      </v-btn>
                      <v-btn
                        @click="deleteMeasures(measure)"
                        class="mx-2"
                        color="red accent-4"
                        fab
                        x-small
                        dark
                      >
                        <v-icon dark>mdi-delete</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" dark @click="closeModal">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <PDFTrace
      :openModal="modalPdf"
      @close-modal="modalPdf = false"
      :measure="measure"
      v-if="modalPdf"
    />
    <Dialog :isDialogOpen="isMeasureDialogOpen">
      <template v-slot:body>
        <Measure :measure="measure" @close="closeMeasures" />
      </template>
      <template v-slot:footer>
        <v-spacer />
        <v-btn @click="isMeasureDialogOpen = false">Cancelar</v-btn>
        <v-btn
          class="success"
          @click="$store.commit('measure/changeFormStatus', true)"
          >Actualizar</v-btn
        >
      </template>
    </Dialog>
  </v-app>
</template>

<script>
import Dialog from "../../Utils/Dialog.vue";
import Measure from "./Forms/Measure.vue";
import PDFTrace from "./PDFTrace";
import Swal from 'sweetalert2';
export default {
  name: "Trace",
  components: { PDFTrace, Dialog, Measure },
  props: ["openModal", "patient"],
  data() {
    return {
      modalStatus: this.openModal,
      data: this.patient,
      modalPdf: false,
      measure: null,
      isMeasureDialogOpen: false,
    };
  },
  methods: {
    closeModal() {
      this.modalStatus = false;
      this.$emit("close-modal");
    },
    getIcon(value) {
      if (value > 0) {
        return "chevron-up";
      }
      if (value < 0) {
        return "chevron-down";
      }
      if (value == 0) {
        return "equal";
      }
    },
    showPDF(measure) {
      this.measure =
        this.$store.state.apiUrl + "formats/measures/" + measure.id;
      this.modalPdf = true;
    },
    editMeasures(measure) {
      this.measure = measure;
      this.isMeasureDialogOpen = true;
    },
    deleteMeasures(measure) {
      Swal.fire({
        title: "¿Está seguro?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.value) {
          this.openLoader();
          const request = this.sendRequest(
            this.$store.state.apiUrl +
              "catalogs/patients/" +
              this.patient.id +
              "/measures/" +
              measure.id,
            {},
            "DELETE"
          );
          request
            .then(({ message }) => {
              this.showSuccessMessage(message);
              this.isMeasureDialogOpen = false;
              this.$emit("refresh-trace");
            })
            .finally(this.closeLoader());
        }
      });
    },
    closeMeasures() {
      this.isMeasureDialogOpen = false;
      this.$emit("refresh-trace");
    },
  },
};
</script>
